import type {RoundStepEnum} from './RoundStepEnum';
import type {RoundTypeEnum} from './RoundTypeEnum';

export type ValidityRequestBody = {
  /**
   * Date from which the validity is valid
   */
  validFrom: string;
  roundType: RoundTypeEnum;
  roundStep: RoundStepEnum;
  /**
   * Will be the rounding item taxed or not?
   */
  taxRounding: boolean;
};
